// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Ih74","title":"Header_title__8DveM","side":"Header_side__2x087"};